import { useCallback, useState } from 'react'
import { FiTrash2, FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { deleteDiscount } from '~/modules/sales/services'

type Props = {
  onSuccess?: () => void
  discountId: string
}

export const DeleteDiscountButton: React.FC<Props> = ({
  onSuccess,
  discountId,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleCloseModal = useCallback(() => {
    setShowModal(false)
  }, [])

  const handleOpenModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const handleDeleteDiscount = useCallback(
    async (id: string) => {
      setLoading(true)
      await deleteDiscount(id).then(() => {
        onSuccess?.()
        setShowModal(false)
      })
      setLoading(false)
    },
    [onSuccess],
  )

  return (
    <>
      <button
        className='py-2 px-4 rounded-md bg-gpa-red hover:bg-red-500
          text-white'
        onClick={handleOpenModal}
      >
        <FiTrash2 size={18} />
      </button>

      <Modal visible={showModal}>
        <div className='flex flex-col'>
          <div className='flex items-center justify-between mb-4'>
            <h1 className='text-xl'>Excluir Desconto</h1>
            <button
              type='button'
              className='p-2 rounded-full hover:bg-slate-50'
              onClick={handleCloseModal}
            >
              <FiX size={26} />
            </button>
          </div>
          <div className='flex flex-col gap-4'>
            <p>
              Você tem certeza que deseja excluir este desconto? Esta ação não
              pode ser desfeita.
            </p>
            <div className='flex justify-end gap-4 mt-3'>
              <Button
                loading={loading}
                color='error'
                onClick={() => handleDeleteDiscount(discountId)}
              >
                Excluir
              </Button>
              <Button mode='blank' color='error' onClick={handleCloseModal}>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
